import { createVisitaPhotoDependencies } from './visitaOfflinePhotoDependencies.js';

export function offlinePdfSpec(item) {
    if (!item || !/^[a-f0-9-]{36}$/.test(item.client_uuid || '') || !/^[a-f0-9]{64}$/.test(item.file_sha256 || '')
        || !Number.isSafeInteger(item.size) || item.size < 1 || item.size > 20 * 1024 * 1024
        || item.tipo !== 'application/pdf' || !String(item.path || '').endsWith('.pdf')) return null;
    return { sha256: item.file_sha256, size: item.size, mime: 'application/pdf' };
}
export function createVisitaPdfDependencies(options) {
    return createVisitaPhotoDependencies({ ...options, category: 'document', specFor: offlinePdfSpec,
        itemsFor: source => source.context.visita.adjuntos_documentacion, fileKind: 'downloaded_document',
        manifestKind: 'pdf_dependencies', manifestSuffix: 'pdfs', resetOthers: false });
}
export function combineVisitaFileDependencies(photos, documents) {
    return { prepare: async (source, dependencies) => documents.prepare(source, await photos.prepare(source, dependencies)),
        inspect: async (source, dependencies) => documents.inspect(source, await photos.inspect(source, dependencies)) };
}
